
<section class="col-xs-12 col-sm-12 invoices_titlesection">
  <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 invoices_headerparent">
    <div class="invoices_header">{{"allinvoice.uktitle" | cxTranslate}}</div>
    <div class="invoices_dropdown">

      @if (dropdownDetail; as item) {
        <select id="invoices_dropdownselect" (change)="selectedSeason($event)" [(ngModel)]="finalSeason">
          @for (obj of item.seqirusSeasonList; track obj; let i = $index) {
            <option  [value]="obj" id="invoices_dropdownselect-{{i}}"> Viewing Season: {{obj.replace('-20','/')}} </option>
          }
        </select>
      }

    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 invoices_headerparent invoices_headerparent2">
    <div class="invoices_openInvoices">
      <div class="invoices_openInvoicesNo">{{openCount}}</div>
      <div class="invoices_openInvoiceslabel">{{"allinvoice.openinvoicetxt" | cxTranslate}}</div>
    </div>
    <div class="invoices_paidInvoices">
      <div class="invoices_paidInvoicesNo">{{paidCount}}</div>
      <div class="invoices_paidInvoiceslabel">{{"allinvoice.paidinvoicetxt" | cxTranslate}}</div>
    </div>
  </div>
</section>

<div  class="loading">
  <div class="loading_txt">
    <div class="load_txt">{{"allinvoice.loadinglabel" | cxTranslate}}</div>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>